
import image0 from "gallery-image:ua-2021-12-09:L1000970-bw";
import image1 from "gallery-image:ua-2021-12-09:L1000972-color";
import image2 from "gallery-image:ua-2021-12-09:L1000862-bw";
import image3 from "gallery-image:ua-2021-12-09:L1000975-bw";
import image4 from "gallery-image:ua-2021-12-09:L1001041-bw";
import image5 from "gallery-image:ua-2021-12-09:L1001030-color";
import image6 from "gallery-image:ua-2021-12-09:L1000906-bw";
import image7 from "gallery-image:ua-2021-12-09:L1001046-color";
import image8 from "gallery-image:ua-2021-12-09:L1001010-bw";
import image9 from "gallery-image:ua-2021-12-09:L1000885-bw";
import image10 from "gallery-image:ua-2021-12-09:L1000995-color";
import image11 from "gallery-image:ua-2021-12-09:L1001004-bw";
import image12 from "gallery-image:ua-2021-12-09:L1000941-color";
import image13 from "gallery-image:ua-2021-12-09:L1000952-bw";

const images = { 'L1000970-bw': image0,
'L1000972-color': image1,
'L1000862-bw': image2,
'L1000975-bw': image3,
'L1001041-bw': image4,
'L1001030-color': image5,
'L1000906-bw': image6,
'L1001046-color': image7,
'L1001010-bw': image8,
'L1000885-bw': image9,
'L1000995-color': image10,
'L1001004-bw': image11,
'L1000941-color': image12,
'L1000952-bw': image13,
 };
export default {
  ...{"id":"ua-2021-12-09","title":"urban artworks"},
  tiles: [ {
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000970-bw"]
}, 
{
  color: "blue",
  size: "large",
  position: "far-right",
  lift: true,
  image: images["L1000972-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "right",
  lift: false,
  image: images["L1000862-bw"]
}, 
{
  color: "blue",
  size: "x-large",
  position: "left",
  lift: false,
  image: images["L1000975-bw"]
}, 
{
  color: "blue",
  size: "medium",
  position: "far-right",
  lift: false,
  image: images["L1001041-bw"]
}, 
{
  color: "blue",
  size: "x-large",
  position: "left",
  lift: false,
  image: images["L1001030-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "right",
  lift: false,
  image: images["L1000906-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "far-left",
  lift: false,
  image: images["L1001046-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1001010-bw"]
}, 
{
  color: "blue",
  size: "large",
  position: "right",
  lift: false,
  image: images["L1000885-bw"]
}, 
{
  color: "blue",
  size: "medium",
  position: "left",
  lift: false,
  image: images["L1000995-color"]
}, 
{
  color: "blue",
  size: "small",
  position: "far-right",
  lift: false,
  image: images["L1001004-bw"]
}, 
{
  color: "blue",
  size: "small",
  position: "left",
  lift: false,
  image: images["L1000941-color"]
}, 
{
  color: "blue",
  size: "x-large",
  position: "right",
  lift: false,
  image: images["L1000952-bw"]
} ]
};
